<template lang="pug">
.subtitle-text.primary--text Jenis Transfer
  v-radio-group(
    dense,
    v-model="transferType",
    :error="error",
    :error-messages="error ? 'Pilih jenis transfer' : ''",
    :row="row",
    @change="onSelect",
    :readonly="readonly"
  )
    v-radio(label="SKN", value="2", color="primary")
    v-radio(label="RTGS", value="3", color="primary")
</template>
<script>
export default {
  name: "FRadioTransferExt",
  props: ["value", "error", "readonly", "row"],
  data() {
    return {
      transferType: null,
    };
  },
  mounted() {
    this.doInitModel(this.value);
  },
  watch: {
    value(val) {
      this.doInitModel(val);
    },
  },
  methods: {
    doInitModel(values) {
      this.transferType = values ? "" + values : "2";
      this.onSelect();
    },
    onSelect() {
      this.$emit("input", this.transferType);
      this.$emit("select", this.transferType);
    },
  },
};
</script>